import React from 'react'
import { useLocation } from 'react-router-dom'

import routes from '../routes'

import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react'

const AppBreadcrumb = () => {
  const currentLocation = useLocation().pathname

  const getRouteName = (pathname, idPathname, routes) => {
    const currentRoute = routes.find((route) => route.path === pathname)
    const idRoute = routes.find((route) => route.path === idPathname)
    return currentRoute?.name || idRoute?.name
  }

  const getBreadcrumbs = (location) => {
    const breadcrumbs = []
    location.split('/').reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`
      const idPathname = `${prev}/:id`
      if (index >= 3) {
        const idRoute = routes.find((route) => route.path === idPathname)
        if (!!idRoute?.name) {
          breadcrumbs.pop()
        }
      }
      breadcrumbs.push({
        pathname: currentPathname,
        name: getRouteName(currentPathname, idPathname, routes),
        active: index + 1 === array.length ? true : false,
      })
      return currentPathname
    })
    return breadcrumbs
  }

  const breadcrumbs = getBreadcrumbs(currentLocation)

  return (
    <CBreadcrumb className="m-0 ms-0">
      <CBreadcrumbItem href="/">Dashboard</CBreadcrumbItem>
      {breadcrumbs.map((breadcrumb, index) => {
        return (
          <CBreadcrumbItem
            {...(breadcrumb.active ? { active: true } : { href: breadcrumb.pathname })}
            key={index}
          >
            {breadcrumb.name !== 'Dashboard' && breadcrumb.name}
          </CBreadcrumbItem>
        )
      })}
    </CBreadcrumb>
  )
}

export default React.memo(AppBreadcrumb)
